import { Typography, Grid } from "@mui/material";
import React from "react";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";

const AdditionalQuestions = ({
  additionalQuestions,
}: {
  additionalQuestions: string;
}): React.JSX.Element => (
  <React.Fragment>
    <Typography variant="h6" color="initial" sx={{ mb: 1 }}>
      Deine Meinung ist gefragt!
    </Typography>

    {additionalQuestions === "" ? (
      <Typography variant="body1" color="initial">
        keine Angabe
      </Typography>
    ) : (
      <Grid container spacing={1}>
        {additionalQuestions.split(",").map((topic) => {
          if (topic === "") return null;
          return (
            <Grid item xs={12} sm={6} md={4} key={topic}>
              <Typography
                variant="body1"
                color="initial"
                sx={{
                  display: "flex",
                  alignItems: "top",
                  justifyContent: "left",
                }}
              >
                <ArrowRightOutlinedIcon
                  sx={{
                    mr: 1,
                    color: (theme) => theme.palette.primary.main,
                  }}
                />{" "}
                {topic}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
    )}
  </React.Fragment>
);

export default AdditionalQuestions;
